import api from "../../services/api"
import { IApplePayMerchantSession } from "../types/ApplePay"

export const ApplePayController = {
  validateMerchant: async (validationUrl: string): Promise<IApplePayMerchantSession> => {
    const { data } = await api.post<IApplePayMerchantSession>("/api/ApplePay/validate-merchant", {
      validationUrl,
    })
    return data
  },
}
